"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotifyToMarkAnswerPanelHeader = exports.NotifyToMarkAnswerPanelBody = exports.LabelWithInputGroupInText = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Switcher = _interopRequireDefault(require("@insided/deprecated-preact-components/control/Switcher"));

var _PanelItems = require("../registration-rules/PanelItems");

var _Message = require("../ui-components/Message");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _PanelHeaderWithIcon = require("../ui-components/PanelHeaderWithIcon");

var NotifyToMarkAnswerPanelBody = function NotifyToMarkAnswerPanelBody(_ref) {
  var isNotifyMarkAnswerEnabled = _ref.isNotifyMarkAnswerEnabled,
      notifyAfter = _ref.notifyAfter,
      showActionButtons = _ref.showActionButtons,
      showValidationError = _ref.showValidationError,
      _onSave = _ref.onSave,
      _onCancel = _ref.onCancel,
      onInputFocus = _ref.onInputFocus,
      onNotifyMarkAnswerSettingChanged = _ref.onNotifyMarkAnswerSettingChanged,
      onInputChange = _ref.onInputChange,
      onInputBlur = _ref.onInputBlur;
  var isInputEnabled = !isNotifyMarkAnswerEnabled;
  return (0, _preact.h)("div", {
    className: "panel-body-container panel-notify-mark-answer"
  }, (0, _preact.h)("div", {
    className: "panel-switch-input-dropdown-container"
  }, (0, _preact.h)("div", {
    className: "switch-icon-container"
  }, (0, _preact.h)(_Switcher.default, {
    on: isNotifyMarkAnswerEnabled,
    customClass: "panel-switch",
    labelCustomClass: "panel-switch-label panel-notify-mark-answer-switch",
    label: (0, _preact.h)(LabelWithInputGroupInText, {
      isInputEnabled: isInputEnabled,
      ageInDays: notifyAfter,
      onInputChange: onInputChange,
      onInputFocus: onInputFocus,
      onInputBlur: onInputBlur,
      hasError: showValidationError
    }),
    onChange: function onChange() {
      return onNotifyMarkAnswerSettingChanged(!isNotifyMarkAnswerEnabled);
    }
  })), showValidationError && (0, _preact.h)("div", {
    className: "error-message-container"
  }, (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
    customClass: "icon-warning",
    icon: "warning"
  })), (0, _preact.h)("div", {
    className: "error-message"
  }, "Please fill in the required field"))), (0, _preact.h)(_Message.Message, {
    text: (0, _preact.h)("div", null, "You can customize the", ' ', (0, _preact.h)("a", {
      className: "panel-link-text",
      target: "_blank",
      href: (0, _absoluteUrlRuntime.resolveUrl)("/email/system-emails/edit?type=mark-answer-reminder")
    }, "'Is your problem solved?' email template"), ' ', "that is sent out, to match your brand.")
  }), showActionButtons && (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: function onSave() {
      return _onSave();
    },
    onCancel: function onCancel() {
      return _onCancel();
    }
  }));
};

exports.NotifyToMarkAnswerPanelBody = NotifyToMarkAnswerPanelBody;

var LabelWithInputGroupInText = function LabelWithInputGroupInText(_ref2) {
  var isInputEnabled = _ref2.isInputEnabled,
      ageInDays = _ref2.ageInDays,
      onInputChange = _ref2.onInputChange,
      onInputFocus = _ref2.onInputFocus,
      hasError = _ref2.hasError,
      onInputBlur = _ref2.onInputBlur;
  return (0, _preact.h)("div", {
    className: "panel-input-label panel-multi-line-input-label"
  }, "If a question has one or more replies from a user other than the question author, ", (0, _preact.h)("br", {
    className: "breakline"
  }), " after this topic is inactive for", (0, _preact.h)(_InputGroup.default, {
    type: "number",
    min: 1,
    required: true,
    disabled: isInputEnabled,
    value: ageInDays,
    hasError: hasError,
    onChange: function onChange(e) {
      return onInputChange(e.target.value);
    },
    onClick: function onClick() {
      return onInputFocus();
    },
    onBlur: function onBlur() {
      return onInputBlur();
    },
    qaClasses: "qa-notify-mark-answer-age-in-days-input"
  }), ' ', "days, send the topic author the 'Is your problem solved?' email.");
};

exports.LabelWithInputGroupInText = LabelWithInputGroupInText;

var NotifyToMarkAnswerPanelHeader = function NotifyToMarkAnswerPanelHeader(_ref3) {
  var statusText = _ref3.statusText;
  return (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
    customClass: "panel-header-container",
    iconCustomClass: "icon-panel-header",
    icon: "suggestedCircleCheck",
    title: "Ask end users to mark best answer via email",
    statusText: statusText
  });
};

exports.NotifyToMarkAnswerPanelHeader = NotifyToMarkAnswerPanelHeader;